import { Component, Input } from '@angular/core';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { CheckoutCostCenterFacade } from '@spartacus/checkout/b2b/root';
import { CheckoutOrderSummaryComponent, CheckoutStepService } from '@spartacus/checkout/base/components';
import {
  CheckoutDeliveryAddressFacade,
  CheckoutDeliveryModesFacade,
  CheckoutPaymentFacade,
} from '@spartacus/checkout/base/root';
import { CheckoutPaymentTypeFacade } from '@spartacus/checkout/b2b/root';
import { TranslationService, UserAddressService, UserCostCenterService, TranslatePipe } from '@spartacus/core';
import { KnBrDraftOrder } from 'src/app/models/kn-br-draft-order.model';
import { KnBrReviewSubmitComponent } from 'src/app/kn-br-checkout/kn-br-review-submit/kn-br-review-submit.component';
import { KnBrAddress } from 'src/app/models/kn-br-order.model';
import { Observable } from 'rxjs';
import { Card, CardComponent } from '@spartacus/storefront';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
// Need To Discuss
@Component({
    selector: 'cx-order-summary',
    templateUrl: './kn-br-order-summary.component.html',
    imports: [CardComponent, AsyncPipe, TranslatePipe]
})
export class KnBrOrderSummaryComponent extends KnBrReviewSubmitComponent {
  @Input()
  cart: KnBrDraftOrder;

  constructor(
    protected checkoutDeliveryModesFacade: CheckoutDeliveryModesFacade,
    protected checkoutDeliveryService: CheckoutDeliveryAddressFacade,
    protected checkoutPaymentService: CheckoutPaymentFacade,
    protected userAddressService: UserAddressService,
    protected activeCartService: ActiveCartService,
    protected translation: TranslationService,
    protected checkoutStepService: CheckoutStepService,
    protected checkoutPaymentTypeFacade: CheckoutPaymentTypeFacade,
    protected checkoutCostCenterFacade: CheckoutCostCenterFacade,
    protected userCostCenterService: UserCostCenterService
  ) {
    super(
      checkoutDeliveryModesFacade,
      checkoutDeliveryService,
      checkoutPaymentService,
      userAddressService,
      activeCartService,
      translation,
      checkoutStepService,
      checkoutPaymentTypeFacade,
      checkoutCostCenterFacade,
      userCostCenterService
    );
  }
}
